export default __webpack_public_path__ + "static/runbit-logo-1b0fb153ba245d7923b041de6dca44cd.svg";